
import { defineComponent } from "vue";
import Modal from "../layout/Modal.vue";
import RunTime from "./RunTime.vue";
import TimePicker from "./TimePicker.vue";

export default defineComponent({
  name: "SetTimeButton",
  components: { Modal, RunTime, TimePicker },
  data() {
    return {
      showSetTimeModal: false,
      timeSetInModal: 0,
    };
  },
  methods: {
    tg(key: string): string {
      return this.$t("general." + key);
    },
    openSetTimeModal(): void {
      this.showSetTimeModal = true;
    },
    closeSetTimeModal(): void {
      this.showSetTimeModal = false;
    },
    saveTime(): void {
      this.$store.commit("setTime", this.timeSetInModal);
      this.closeSetTimeModal();
    },
  },
});
